<template>
  <s-select
    value-field="id"
    text-field="name"
    :value="value"
    :options="timeZones"
    @input="changeValue"
  />
</template>

<script>
import TimezoneService from '@/domain/services/timezone';

export default {
  name: 'TimezoneSelect',
  props: {
    value: null,
  },
  data: () => ({
    timeZones: [],
  }),
  created() {
    this.loadTimezones();
  },
  methods: {
    loadTimezones() {
      TimezoneService.getTimezones().then((response) => {
        this.timeZones = response.timeZones;
      });
    },
    changeValue(newVal) {
      this.$emit('input', newVal);
    },
  },
};
</script>
<style scoped>
</style>
